import io from "socket.io-client";

const SOCKET_SERVER =
  process.env.REACT_APP_SOCKET_SERVER || "http://localhost:9091";

interface SocketInitOptions {
  mode?: string;
  clientType?: string;
}

const init = (accessToken?: string, options?: SocketInitOptions) => {
  const headers: Record<string, string> = {};
  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }
  if (options?.clientType) {
    headers["x-queue-client"] = options.clientType;
  }

  const socket = io(SOCKET_SERVER, {
    extraHeaders: headers,
    query: options?.mode
      ? {
          mode: options.mode,
        }
      : undefined,
  });

  socket.on("connect", () => {
    console.log("Connected to socket server", socket.id);
  });

  return socket;
};

export default init;
